import { useConfig } from '../../context/ConfigProvider/ConfigProvider';
export const useIsCheckedTestAttribute = (isChecked) => {
    const { isCheckedTestAttributeName } = useConfig();
    return { [isCheckedTestAttributeName]: isChecked };
};
